(function () {
  'use strict';

  if (window.__loantiSpLoaded) {
    return;
  }
  window.__loantiSpLoaded = true;

  var SESSION_KEY = '__loanti_sp_session';
  var STATE_KEY = '__loanti_sp_state';
  var CART_ATTRIBUTE = '__loanti_sp_session';
  var DELIVERY_ATTRIBUTE = 'Metoda dostawy';
  var SESSION_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  var LIMITS_REVISION_KEY = '__loanti_sp_limits_revision';
  var CONFIG_TIMEOUT_MS = 4000;
  var POPUP_VISIBLE_MS = 6500;
  var HEARTBEAT_MS = 30000;
  var SOLD_DAYS = { 7: true, 14: true, 30: true, 60: true };
  var DEFAULT_PAGES = { product: true, collection: true, home: true, cart: false, blog: false, page: false };
  var PAGE_KEYS = ['product', 'collection', 'home', 'cart', 'blog', 'page'];
  var KNOWN_PAGE_TYPES = { product: true, collection: true, home: true, cart: true, blog: true, page: true };

  var config = window.LoantiSocialProofConfig || {};
  var storage = safeStorage();
  var sessionRecord = readOrCreateSession(storage);
  var sessionId = sessionRecord.id;
  var page = readPage();
  var root = null;
  var popup = null;
  var showTimer = null;
  var hideTimer = null;
  var autoHideTimer = null;
  var heartbeatTimer = null;
  var soldTimer = null;
  var lastHeartbeatAt = 0;
  var attributeSync = null;
  var booted = false;

  function safeStorage() {
    try {
      var probe = '__loanti_sp_probe';
      window.localStorage.setItem(probe, '1');
      window.localStorage.removeItem(probe);
      return window.localStorage;
    } catch (error) {
      var memory = {};
      return {
        getItem: function (key) {
          return Object.prototype.hasOwnProperty.call(memory, key) ? memory[key] : null;
        },
        setItem: function (key, value) {
          memory[key] = String(value);
        }
      };
    }
  }

  function isDebug() {
    return window.LOANTI_SOCIAL_PROOF_DEBUG === true || config.debug === true;
  }

  function log() {
    if (!isDebug()) {
      return;
    }
    var args = ['[Loanti Social Proof]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  function finiteNumber(value) {
    var number = Number(value);
    return isFinite(number) ? number : null;
  }

  function clampNumber(value, min, max) {
    var number = finiteNumber(value);
    if (number == null) {
      return null;
    }
    if (number < min) {
      return min;
    }
    if (number > max) {
      return max;
    }
    return number;
  }

  function safeColor(value) {
    var text = String(value == null ? '' : value).trim();
    if (/^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(text)) {
      return text;
    }
    if (/^(?:rgb|rgba|hsl|hsla)\(\s*[0-9.%\s,/+-]+\)$/.test(text)) {
      return text;
    }
    return '';
  }

  function fillTemplate(template, vars) {
    return String(template).replace(/\{\{\s*(count|days)\s*\}\}/g, function (_match, key) {
      return vars && vars[key] != null ? String(vars[key]) : '';
    });
  }

  function normalizeDays(value, fallback) {
    var days = Number(value);
    return SOLD_DAYS[days] ? days : fallback;
  }

  function combinePages(globalPages, popupPages, fallbackPages) {
    var fallback = fallbackPages || DEFAULT_PAGES;
    var pages = {};
    PAGE_KEYS.forEach(function (key) {
      var fromPopup = popupPages && typeof popupPages[key] === 'boolean' ? popupPages[key] : null;
      var fromGlobal = globalPages && typeof globalPages[key] === 'boolean' ? globalPages[key] : null;
      var allowed = fromPopup == null ? (fromGlobal == null ? fallback[key] === true : fromGlobal) : fromPopup;
      if (fromGlobal === false) {
        allowed = false;
      }
      pages[key] = allowed === true;
    });
    return pages;
  }

  function mapDesktopPosition(value, fallback) {
    var text = String(value || '').toLowerCase();
    if (text === 'right' || text === 'bottom_right' || text === 'top_right') {
      return 'right';
    }
    if (text === 'left' || text === 'bottom_left' || text === 'top_left') {
      return 'left';
    }
    return fallback === 'right' ? 'right' : 'left';
  }

  function mapMobilePosition(value, fallback) {
    var text = String(value || '').toLowerCase();
    if (!text) {
      return fallback || 'bottom';
    }
    if (text === 'above-sticky' || text === 'above_sticky') {
      return 'above-sticky';
    }
    if (text === 'right' || text === 'bottom_right') {
      return 'right';
    }
    if (text === 'left' || text === 'bottom_left') {
      return 'left';
    }
    if (text === 'bottom' || text === 'bottom_center') {
      return 'bottom';
    }
    return fallback || 'bottom';
  }

  function mapAnimation(value) {
    var text = String(value || '').toLowerCase();
    if (text === 'fade' || text === 'slide' || text === 'none' || text === 'fade_slide') {
      return text;
    }
    return 'fade_slide';
  }

  function assignDelay(frequency, key, value) {
    var number = clampNumber(value, 0, 600);
    if (number != null) {
      frequency[key] = number;
    }
  }

  function popupPart(source, defaults) {
    var src = source || {};
    var base = defaults || {};
    var seconds = clampNumber(src.displaySeconds, 1, 30);
    return {
      enabled: src.enabled !== false,
      text: src.text || base.text || '',
      displaySeconds: seconds == null ? (base.displaySeconds || 6.5) : seconds,
      showImage: src.showImage !== false,
      showTitle: src.showTitle !== false,
      showClose: src.showClose !== false,
      clickOpensProduct: src.clickOpensProduct !== false
    };
  }

  function mergeConfig(local, remote) {
    var base = local || {};
    var frequency = base.frequency || {};
    var viewers = base.viewerCounter || {};
    var sold = base.soldCounter || {};
    var maxPopups = finiteNumber(frequency.maxPopups);
    var muteSeconds = clampNumber(base.muteAfterAddToCartSeconds, 0, 3600);
    var cfg = {
      enabled: base.enabled !== false,
      apiBase: String(base.apiBase || 'https://importer.4volte.pl/public/social-proof').replace(/\/$/, ''),
      debug: base.debug === true,
      source: remote ? 'backend' : 'fallback',
      limitsRevision: null,
      purchasePopup: popupPart(base.purchasePopup, {
        text: 'Ktoś właśnie kupił',
        displaySeconds: 6.5
      }),
      cartPopup: popupPart(base.cartPopup, {
        text: 'Ktoś dodał ten produkt do koszyka',
        displaySeconds: 6.5
      }),
      viewerCounter: {
        enabled: viewers.enabled !== false,
        minCount: clampNumber(viewers.minCount, 1, 9999) || 1,
        textOne: viewers.textOne || '',
        textMany: viewers.textMany || '',
        fontSize: clampNumber(viewers.fontSize, 10, 28),
        color: safeColor(viewers.color),
        iconColor: safeColor(viewers.iconColor)
      },
      soldCounter: {
        enabled: sold.enabled !== false,
        days: normalizeDays(sold.days, 30),
        minCount: clampNumber(sold.minCount, 1, 9999) || 1,
        textOne: sold.textOne || '',
        textMany: sold.textMany || '',
        fontSize: clampNumber(sold.fontSize, 10, 28),
        color: safeColor(sold.color)
      },
      frequency: {
        maxPopups: maxPopups == null ? 3 : clampNumber(maxPopups, 0, 30),
        windowMinutes: clampNumber(frequency.windowMinutes, 1, 240) || 30,
        initialMin: clampNumber(frequency.initialMin, 0, 600) || 0,
        initialMax: clampNumber(frequency.initialMax, 0, 600) || 0,
        nextMin: clampNumber(frequency.nextMin, 0, 600) || 0,
        nextMax: clampNumber(frequency.nextMax, 0, 600) || 0,
        thirdMin: clampNumber(frequency.thirdMin, 0, 600) || 0,
        thirdMax: clampNumber(frequency.thirdMax, 0, 600) || 0
      },
      randomDelays: base.randomDelays !== false,
      allowRepeatEvent: base.allowRepeatEvent === true,
      keepLimitOnRefresh: base.keepLimitOnRefresh !== false,
      muteAfterAddToCartSeconds: muteSeconds == null ? 120 : muteSeconds,
      desktopPosition: mapDesktopPosition(base.desktopPosition, 'left'),
      mobilePosition: mapMobilePosition(base.mobilePosition, 'above-sticky'),
      appearance: {
        animation: 'fade_slide',
        background: '',
        textColor: '',
        accentColor: '',
        borderColor: '',
        borderWidth: null,
        radius: null,
        shadow: null,
        widthDesktop: null,
        widthTablet: null,
        imageSize: null,
        kickerSize: null,
        titleSize: null,
        animationMs: null,
        marginMobile: null,
        stickyGap: null
      }
    };

    cfg.purchasePopup.pages = combinePages(null, base.purchasePopup && base.purchasePopup.pages);
    cfg.cartPopup.pages = combinePages(null, base.cartPopup && base.cartPopup.pages);

    if (!remote || typeof remote !== 'object') {
      return cfg;
    }

    if (typeof remote.enabled === 'boolean') {
      cfg.enabled = remote.enabled;
    }
    if (typeof remote.debug === 'boolean') {
      cfg.debug = remote.debug;
    }
    if (remote.limits_revision != null && remote.limits_revision !== '') {
      cfg.limitsRevision = remote.limits_revision;
    }
    if (typeof remote.allow_repeat_event === 'boolean') {
      cfg.allowRepeatEvent = remote.allow_repeat_event;
    }
    if (typeof remote.random_delays === 'boolean') {
      cfg.randomDelays = remote.random_delays;
    }
    if (typeof remote.keep_limit_on_refresh === 'boolean') {
      cfg.keepLimitOnRefresh = remote.keep_limit_on_refresh;
    }
    if (remote.mute_after_cart_seconds != null) {
      var remoteMute = clampNumber(remote.mute_after_cart_seconds, 0, 3600);
      if (remoteMute != null) {
        cfg.muteAfterAddToCartSeconds = remoteMute;
      }
    }
    if (remote.max_popups != null) {
      var remoteMax = clampNumber(remote.max_popups, 0, 30);
      if (remoteMax != null) {
        cfg.frequency.maxPopups = remoteMax;
      }
    }
    if (remote.window_minutes != null) {
      var remoteWindow = clampNumber(remote.window_minutes, 1, 240);
      if (remoteWindow != null) {
        cfg.frequency.windowMinutes = remoteWindow;
      }
    }

    var purchase = remote.purchase || {};
    if (typeof purchase.enabled === 'boolean') {
      cfg.purchasePopup.enabled = purchase.enabled;
    }
    if (purchase.text) {
      cfg.purchasePopup.text = String(purchase.text);
    }
    if (purchase.display_seconds != null) {
      var purchaseSeconds = clampNumber(purchase.display_seconds, 1, 30);
      if (purchaseSeconds != null) {
        cfg.purchasePopup.displaySeconds = purchaseSeconds;
      }
    }
    if (typeof purchase.show_image === 'boolean') {
      cfg.purchasePopup.showImage = purchase.show_image;
    }
    if (typeof purchase.show_title === 'boolean') {
      cfg.purchasePopup.showTitle = purchase.show_title;
    }
    if (typeof purchase.show_close === 'boolean') {
      cfg.purchasePopup.showClose = purchase.show_close;
    }
    if (typeof purchase.click_opens_product === 'boolean') {
      cfg.purchasePopup.clickOpensProduct = purchase.click_opens_product;
    }
    assignDelay(cfg.frequency, 'initialMin', purchase.first_min);
    assignDelay(cfg.frequency, 'initialMax', purchase.first_max);
    assignDelay(cfg.frequency, 'nextMin', purchase.next_min);
    assignDelay(cfg.frequency, 'nextMax', purchase.next_max);
    assignDelay(cfg.frequency, 'thirdMin', purchase.third_min);
    assignDelay(cfg.frequency, 'thirdMax', purchase.third_max);

    var cartRemote = remote.add_to_cart || {};
    if (typeof cartRemote.enabled === 'boolean') {
      cfg.cartPopup.enabled = cartRemote.enabled;
    }
    if (cartRemote.text) {
      cfg.cartPopup.text = String(cartRemote.text);
    }
    if (cartRemote.display_seconds != null) {
      var cartSeconds = clampNumber(cartRemote.display_seconds, 1, 30);
      if (cartSeconds != null) {
        cfg.cartPopup.displaySeconds = cartSeconds;
      }
    }
    if (typeof cartRemote.show_image === 'boolean') {
      cfg.cartPopup.showImage = cartRemote.show_image;
    }
    if (typeof cartRemote.show_title === 'boolean') {
      cfg.cartPopup.showTitle = cartRemote.show_title;
    }
    if (typeof cartRemote.show_close === 'boolean') {
      cfg.cartPopup.showClose = cartRemote.show_close;
    }
    if (typeof cartRemote.click_opens_product === 'boolean') {
      cfg.cartPopup.clickOpensProduct = cartRemote.click_opens_product;
    }

    cfg.purchasePopup.pages = combinePages(remote.pages, purchase.pages, cfg.purchasePopup.pages);
    cfg.cartPopup.pages = combinePages(remote.pages, cartRemote.pages, cfg.cartPopup.pages);

    if (remote.viewers && typeof remote.viewers === 'object') {
      if (typeof remote.viewers.enabled === 'boolean') {
        cfg.viewerCounter.enabled = remote.viewers.enabled;
      }
      if (remote.viewers.min_count != null) {
        var minViewers = clampNumber(remote.viewers.min_count, 1, 9999);
        if (minViewers != null) {
          cfg.viewerCounter.minCount = minViewers;
        }
      }
      if (remote.viewers.text_one) {
        cfg.viewerCounter.textOne = String(remote.viewers.text_one);
      }
      if (remote.viewers.text_many) {
        cfg.viewerCounter.textMany = String(remote.viewers.text_many);
      }
      if (remote.viewers.font_size != null) {
        cfg.viewerCounter.fontSize = clampNumber(remote.viewers.font_size, 10, 28);
      }
      if (safeColor(remote.viewers.text_color)) {
        cfg.viewerCounter.color = safeColor(remote.viewers.text_color);
      }
      if (safeColor(remote.viewers.icon_color)) {
        cfg.viewerCounter.iconColor = safeColor(remote.viewers.icon_color);
      }
    }

    if (remote.sold && typeof remote.sold === 'object') {
      if (typeof remote.sold.enabled === 'boolean') {
        cfg.soldCounter.enabled = remote.sold.enabled;
      }
      if (remote.sold.days != null) {
        cfg.soldCounter.days = normalizeDays(remote.sold.days, cfg.soldCounter.days);
      }
      if (remote.sold.min_count != null) {
        var minSold = clampNumber(remote.sold.min_count, 1, 9999);
        if (minSold != null) {
          cfg.soldCounter.minCount = minSold;
        }
      }
      if (remote.sold.text_one) {
        cfg.soldCounter.textOne = String(remote.sold.text_one);
      }
      if (remote.sold.text_many) {
        cfg.soldCounter.textMany = String(remote.sold.text_many);
      }
      if (remote.sold.font_size != null) {
        cfg.soldCounter.fontSize = clampNumber(remote.sold.font_size, 10, 28);
      }
      if (safeColor(remote.sold.color)) {
        cfg.soldCounter.color = safeColor(remote.sold.color);
      }
    }

    var look = remote.appearance && typeof remote.appearance === 'object' ? remote.appearance : null;
    if (look) {
      cfg.appearance.background = safeColor(look.background);
      cfg.appearance.textColor = safeColor(look.text_color);
      cfg.appearance.accentColor = safeColor(look.accent_color);
      cfg.appearance.borderColor = safeColor(look.border_color) || safeColor(look.accent_color);
      cfg.appearance.borderWidth = clampNumber(look.border_width, 0, 8);
      cfg.appearance.radius = clampNumber(look.radius, 0, 40);
      cfg.appearance.shadow = typeof look.shadow === 'boolean' ? look.shadow : null;
      cfg.appearance.widthDesktop = clampNumber(look.width_desktop, 240, 560);
      cfg.appearance.widthTablet = clampNumber(look.width_tablet, 240, 560);
      cfg.appearance.imageSize = clampNumber(look.image_size, 32, 96);
      cfg.appearance.kickerSize = clampNumber(look.title_size, 10, 28);
      cfg.appearance.titleSize = clampNumber(look.name_size, 10, 32);
      cfg.appearance.animation = mapAnimation(look.animation);
      cfg.appearance.animationMs = clampNumber(look.animation_ms, 0, 2000);
      cfg.appearance.marginMobile = clampNumber(look.margin_mobile, 0, 48);
      cfg.appearance.stickyGap = clampNumber(look.sticky_gap, 0, 120);
      if (look.position_desktop) {
        cfg.desktopPosition = mapDesktopPosition(look.position_desktop, cfg.desktopPosition);
      }
      if (look.position_mobile) {
        cfg.mobilePosition = mapMobilePosition(look.position_mobile, cfg.mobilePosition);
      }
    }

    return cfg;
  }

  function appearanceVars(current) {
    var look = (current && current.appearance) || {};
    var viewers = (current && current.viewerCounter) || {};
    var sold = (current && current.soldCounter) || {};
    var vars = {};
    if (look.background) {
      vars['--loanti-sp-bg'] = look.background;
    }
    if (look.textColor) {
      vars['--loanti-sp-text'] = look.textColor;
    }
    if (look.accentColor) {
      vars['--loanti-sp-accent'] = look.accentColor;
    }
    if (look.borderColor) {
      vars['--loanti-sp-border'] = look.borderColor;
    }
    if (look.borderWidth != null) {
      vars['--loanti-sp-border-width'] = look.borderWidth + 'px';
    }
    if (look.radius != null) {
      vars['--loanti-sp-radius'] = look.radius + 'px';
    }
    if (look.shadow === false) {
      vars['--loanti-sp-shadow'] = 'none';
    }
    if (look.widthDesktop != null) {
      vars['--loanti-sp-width'] = look.widthDesktop + 'px';
    }
    if (look.widthTablet != null) {
      vars['--loanti-sp-width-tablet'] = look.widthTablet + 'px';
    }
    if (look.imageSize != null) {
      vars['--loanti-sp-image'] = look.imageSize + 'px';
    }
    if (look.kickerSize != null) {
      vars['--loanti-sp-kicker-size'] = look.kickerSize + 'px';
    }
    if (look.titleSize != null) {
      vars['--loanti-sp-title-size'] = look.titleSize + 'px';
    }
    if (look.animationMs != null) {
      vars['--loanti-sp-anim'] = look.animationMs + 'ms';
    }
    if (look.marginMobile != null) {
      vars['--loanti-sp-edge'] = look.marginMobile + 'px';
    }
    if (look.stickyGap != null) {
      vars['--loanti-sp-sticky-gap'] = look.stickyGap + 'px';
    }
    if (viewers.fontSize != null) {
      vars['--loanti-sp-viewers-size'] = viewers.fontSize + 'px';
    }
    if (viewers.color) {
      vars['--loanti-sp-viewers-color'] = viewers.color;
    }
    if (viewers.iconColor) {
      vars['--loanti-sp-viewers-icon'] = viewers.iconColor;
    }
    if (sold.fontSize != null) {
      vars['--loanti-sp-sold-size'] = sold.fontSize + 'px';
    }
    if (sold.color) {
      vars['--loanti-sp-sold-color'] = sold.color;
    }
    return vars;
  }

  function setCssVars(node, vars) {
    if (!node || !node.style || !vars) {
      return;
    }
    Object.keys(vars).forEach(function (key) {
      if (vars[key] != null && vars[key] !== '') {
        node.style.setProperty(key, vars[key]);
      }
    });
  }

  function applyAppearance(current) {
    var source = current || config;
    var vars = appearanceVars(source);
    var rootNode = document.querySelector('[data-loanti-social-proof]');
    if (rootNode) {
      setCssVars(rootNode, vars);
      rootNode.classList.remove('is-pos-right', 'is-pos-left', 'is-mobile-pos-right', 'is-mobile-pos-left', 'is-anim-fade', 'is-anim-slide', 'is-anim-none');
      if (source.desktopPosition === 'right') {
        rootNode.classList.add('is-pos-right');
      } else {
        rootNode.classList.add('is-pos-left');
      }
      if (source.mobilePosition === 'right') {
        rootNode.classList.add('is-mobile-pos-right');
      } else if (source.mobilePosition === 'left') {
        rootNode.classList.add('is-mobile-pos-left');
      }
      var animation = source.appearance && source.appearance.animation;
      if (animation === 'fade') {
        rootNode.classList.add('is-anim-fade');
      } else if (animation === 'slide') {
        rootNode.classList.add('is-anim-slide');
      } else if (animation === 'none') {
        rootNode.classList.add('is-anim-none');
      }
    }
    if (document.documentElement) {
      setCssVars(document.documentElement, vars);
    }
  }

  function clearShownLimits() {
    var state = loadState();
    state.shownAt = [];
    saveState(state);
  }

  function applyLimitsRevision(revision) {
    var next = String(revision);
    var prev = null;
    try {
      prev = storage.getItem(LIMITS_REVISION_KEY);
    } catch (error) {
      prev = null;
    }
    var changed = prev != null && prev !== next;
    if (changed) {
      clearShownLimits();
    }
    try {
      storage.setItem(LIMITS_REVISION_KEY, next);
    } catch (error) {
      /* brak zapisu rewizji nie zatrzymuje sklepu */
    }
    return changed;
  }

  function loadRemoteConfig(local, timeoutMs) {
    var sourceLocal = local || window.LoantiSocialProofConfig || {};
    var base = String(sourceLocal.apiBase || 'https://importer.4volte.pl/public/social-proof').replace(/\/$/, '');
    var url = base + '/config';
    var timeout = Number(timeoutMs);
    if (!isFinite(timeout) || timeout <= 0) {
      timeout = CONFIG_TIMEOUT_MS;
    }
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () {
      if (controller) {
        controller.abort();
      }
    }, timeout);
    var request = {
      method: 'GET',
      headers: { Accept: 'application/json' },
      mode: 'cors',
      credentials: 'omit'
    };
    if (controller) {
      request.signal = controller.signal;
    }

    return fetch(url, request).then(function (response) {
      if (!response || !response.ok) {
        throw new Error('config http');
      }
      return response.json();
    }).then(function (data) {
      var remote = data && data.config;
      if (!data || data.ok === false || !remote || typeof remote !== 'object') {
        throw new Error('config bad');
      }
      return {
        config: mergeConfig(sourceLocal, remote),
        source: 'backend'
      };
    }).catch(function () {
      return {
        config: mergeConfig(sourceLocal, null),
        source: 'fallback'
      };
    }).then(function (result) {
      clearTimeout(timer);
      return result;
    });
  }

  function applyLoadedConfig(result) {
    config = result && result.config ? result.config : mergeConfig(window.LoantiSocialProofConfig || {}, null);
    var source = result && result.source === 'backend' ? 'backend' : 'fallback';
    config.source = source;
    log('config pobrano z backendu', source === 'backend');
    log('źródło configu', source);
    log('limits_revision', config.limitsRevision);
    if (source === 'backend' && config.limitsRevision != null && config.limitsRevision !== '') {
      log('reset limitów popupów', applyLimitsRevision(config.limitsRevision));
    }
    if (config.keepLimitOnRefresh === false) {
      clearShownLimits();
      log('limity popupów nie są trzymane po odświeżeniu');
    }
    log('konfiguracja', config);
    if (config.enabled !== false) {
      applyAppearance(config);
    }
    start();
  }

  function boot() {
    var local = window.LoantiSocialProofConfig || {};
    return loadRemoteConfig(local).then(applyLoadedConfig, function () {
      applyLoadedConfig({
        config: mergeConfig(local, null),
        source: 'fallback'
      });
    });
  }

  function pageAllowed(popupConfig, pageType) {
    if (!pageType || pageType === 'checkout') {
      return false;
    }
    var pages = popupConfig && popupConfig.pages;
    if (pages && typeof pages === 'object') {
      return pages[pageType] === true;
    }
    return DEFAULT_PAGES[pageType] === true;
  }

  function popupRunsOnPage(popupConfig, pageType) {
    if (!popupConfig || popupConfig.enabled === false) {
      return false;
    }
    return pageAllowed(popupConfig, pageType);
  }

  function passesMinimum(count, minCount) {
    var number = Number(count) || 0;
    var min = Number(minCount);
    if (!isFinite(min) || min < 1) {
      min = 1;
    }
    return number >= min;
  }

  function normalizeSession(value) {
    var text = String(value || '').trim().toLowerCase();
    return SESSION_RE.test(text) ? text : '';
  }

  function createSessionId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID().toLowerCase();
    }

    var bytes = new Uint8Array(16);
    if (window.crypto && window.crypto.getRandomValues) {
      window.crypto.getRandomValues(bytes);
    } else {
      for (var i = 0; i < 16; i += 1) {
        bytes[i] = Math.floor(Math.random() * 256);
      }
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    var hex = [];
    for (var j = 0; j < 16; j += 1) {
      hex.push((bytes[j] + 0x100).toString(16).slice(1));
    }
    return (
      hex.slice(0, 4).join('') + '-' +
      hex.slice(4, 6).join('') + '-' +
      hex.slice(6, 8).join('') + '-' +
      hex.slice(8, 10).join('') + '-' +
      hex.slice(10, 16).join('')
    );
  }

  function readOrCreateSession(store) {
    var existing = '';
    try {
      existing = normalizeSession(store.getItem(SESSION_KEY));
    } catch (error) {
      existing = '';
    }
    if (existing) {
      return { id: existing, created: false };
    }
    var id = createSessionId();
    try {
      store.setItem(SESSION_KEY, id);
    } catch (error) {
      /* sesja zostaje w pamięci tej strony */
    }
    return { id: id, created: true };
  }

  function loadState() {
    try {
      var raw = storage.getItem(STATE_KEY);
      var parsed = raw ? JSON.parse(raw) : null;
      if (!parsed || typeof parsed !== 'object') {
        parsed = {};
      }
      return {
        shownAt: Array.isArray(parsed.shownAt) ? parsed.shownAt.filter(function (value) {
          return typeof value === 'number';
        }) : [],
        seenIds: Array.isArray(parsed.seenIds) ? parsed.seenIds.map(function (value) {
          return String(value);
        }) : [],
        muteUntil: typeof parsed.muteUntil === 'number' ? parsed.muteUntil : 0
      };
    } catch (error) {
      return { shownAt: [], seenIds: [], muteUntil: 0 };
    }
  }

  function saveState(state) {
    try {
      storage.setItem(STATE_KEY, JSON.stringify({
        shownAt: state.shownAt || [],
        seenIds: (state.seenIds || []).slice(-150),
        muteUntil: state.muteUntil || 0
      }));
    } catch (error) {
      /* limit popupów nie przeżyje odświeżenia, jeśli przeglądarka blokuje zapis */
    }
  }

  function readPage() {
    var node = document.getElementById('loanti-social-proof-context');
    var data = {};
    if (node) {
      try {
        data = JSON.parse(node.textContent || '{}') || {};
      } catch (error) {
        data = {};
      }
    }
    return {
      pageType: String(data.pageType || 'other'),
      productId: String(data.productId || ''),
      variantId: String(data.variantId || ''),
      collectionId: String(data.collectionId || ''),
      productTitle: String(data.productTitle || ''),
      productUrl: String(data.productUrl || ''),
      productImage: String(data.productImage || ''),
      shopOrigin: String(data.shopOrigin || '').replace(/\/$/, '')
    };
  }

  function randomInt(min, max) {
    var lo = Math.ceil(Number(min) || 0);
    var hi = Math.floor(Number(max) || 0);
    if (hi < lo) {
      hi = lo;
    }
    return lo + Math.floor(Math.random() * (hi - lo + 1));
  }

  function soldDays(current) {
    var source = current || config;
    var days = Number(source.soldCounter && source.soldCounter.days);
    return SOLD_DAYS[days] ? days : 30;
  }

  function viewerText(count, current) {
    var source = ((current || config).viewerCounter) || {};
    var n = Number(count) || 0;
    if (n <= 0) {
      return '';
    }
    if (n === 1 && source.textOne) {
      return fillTemplate(source.textOne, { count: n });
    }
    if (n !== 1 && source.textMany) {
      return fillTemplate(source.textMany, { count: n });
    }
    if (n === 1) {
      return '1 osoba ogląda teraz ten produkt';
    }
    var mod10 = n % 10;
    var mod100 = n % 100;
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
      return n + ' osoby oglądają teraz ten produkt';
    }
    return n + ' osób ogląda teraz ten produkt';
  }

  function soldText(count, days, current) {
    var source = ((current || config).soldCounter) || {};
    var n = Number(count) || 0;
    var windowDays = Number(days) || soldDays(current);
    if (n <= 0) {
      return '';
    }
    if (n === 1 && source.textOne) {
      return fillTemplate(source.textOne, { count: n, days: windowDays });
    }
    if (source.textMany) {
      return fillTemplate(source.textMany, { count: n, days: windowDays });
    }
    return 'Kupiono już ' + n + ' szt. w ostatnich ' + windowDays + ' dniach';
  }

  function absoluteUrl(url, origin) {
    var text = String(url || '').trim();
    if (!text) {
      return '';
    }
    if (text.indexOf('//') === 0) {
      return 'https:' + text;
    }
    if (text.indexOf('data:image/') === 0) {
      return text;
    }
    if (text.indexOf('https://') === 0 || text.indexOf('http://') === 0) {
      return text.replace(/^http:\/\//, 'https://');
    }
    if (text.charAt(0) === '/' && origin) {
      return origin + text;
    }
    return '';
  }

  function numericId(value) {
    var text = String(value || '').trim();
    return /^[0-9]+$/.test(text) ? text : '';
  }

  function activeShows(state, now, windowMs) {
    return (state.shownAt || []).filter(function (ts) {
      return now - ts < windowMs;
    }).sort(function (a, b) {
      return a - b;
    });
  }

  function planWait(state, now, currentConfig, options, randomFn) {
    var frequency = currentConfig.frequency || {};
    var windowMinutes = Number(frequency.windowMinutes);
    if (!isFinite(windowMinutes) || windowMinutes <= 0) {
      windowMinutes = 30;
    }
    var windowMs = windowMinutes * 60 * 1000;
    var maxPopups = Number(frequency.maxPopups);
    if (!isFinite(maxPopups) || maxPopups < 0) {
      maxPopups = 3;
    }
    var pageType = options && options.pageType;
    var roll = randomFn || randomInt;

    if (currentConfig.enabled === false) {
      return { stop: true, reason: 'off', waitMs: 0 };
    }
    if (pageType === 'checkout') {
      return { stop: true, reason: 'page', waitMs: 0 };
    }
    var purchaseEnabled = !!(currentConfig.purchasePopup && currentConfig.purchasePopup.enabled);
    var cartEnabled = !!(currentConfig.cartPopup && currentConfig.cartPopup.enabled);
    if (!purchaseEnabled && !cartEnabled) {
      return { stop: true, reason: 'popups-off', waitMs: 0 };
    }
    if (!popupRunsOnPage(currentConfig.purchasePopup, pageType) && !popupRunsOnPage(currentConfig.cartPopup, pageType)) {
      return { stop: true, reason: 'page', waitMs: 0 };
    }
    if (options && options.drawerOpen) {
      return { stop: false, reason: 'drawer', waitMs: 2000 };
    }

    var muteLeft = Math.max(0, (state.muteUntil || 0) - now);
    if (muteLeft > 0) {
      return { stop: false, reason: 'mute', waitMs: muteLeft };
    }

    var active = activeShows(state, now, windowMs);
    if (active.length >= maxPopups) {
      return {
        stop: false,
        reason: 'cap',
        waitMs: Math.max(1000, active[0] + windowMs - now + 250),
        active: active.length
      };
    }

    var min;
    var max;
    if (active.length <= 0) {
      min = frequency.initialMin;
      max = frequency.initialMax;
    } else if (active.length === 1) {
      min = frequency.nextMin;
      max = frequency.nextMax;
    } else {
      min = frequency.thirdMin;
      max = frequency.thirdMax;
    }

    var seconds = currentConfig.randomDelays === false ? (Number(min) || 0) : roll(min, max);
    return {
      stop: false,
      reason: 'delay',
      waitMs: seconds * 1000,
      seconds: seconds,
      active: active.length,
      min: min,
      max: max
    };
  }

  function eventRank(event, currentPage) {
    if (currentPage.pageType === 'product') {
      if (currentPage.productId && String(event.product_id) === String(currentPage.productId)) {
        return 0;
      }
      if (currentPage.collectionId && String(event.collection_id) === String(currentPage.collectionId)) {
        return 1;
      }
      return 2;
    }
    if (currentPage.pageType === 'collection') {
      if (currentPage.collectionId && String(event.collection_id) === String(currentPage.collectionId)) {
        return 0;
      }
      return 1;
    }
    return 0;
  }

  function pickEvent(events, currentPage, seenIds, currentConfig) {
    var seen = {};
    (seenIds || []).forEach(function (id) {
      seen[String(id)] = true;
    });

    var list = (events || []).filter(function (event) {
      if (!event || !event.id || currentConfig.enabled === false) {
        return false;
      }
      if (!currentConfig.allowRepeatEvent && seen[String(event.id)]) {
        return false;
      }
      if (event.event_type === 'purchase') {
        return popupRunsOnPage(currentConfig.purchasePopup, currentPage && currentPage.pageType);
      }
      if (event.event_type === 'add_to_cart') {
        return popupRunsOnPage(currentConfig.cartPopup, currentPage && currentPage.pageType);
      }
      return false;
    }).filter(function (event) {
      return String(event.product_title || '').trim() && String(event.product_url || '').trim();
    });

    list.sort(function (a, b) {
      var rankDiff = eventRank(a, currentPage) - eventRank(b, currentPage);
      if (rankDiff !== 0) {
        return rankDiff;
      }
      return (Number(b.occurred_at) || 0) - (Number(a.occurred_at) || 0);
    });

    return list[0] || null;
  }

  function buildHeartbeatPayload(currentPage, currentSession) {
    var productId = numericId(currentPage.productId);
    if (!productId || !normalizeSession(currentSession)) {
      return null;
    }
    return {
      session_id: currentSession,
      product_id: productId,
      collection_id: numericId(currentPage.collectionId)
    };
  }

  function buildAddToCartPayload(item, currentSession, currentPage) {
    var source = item || {};
    var productId = numericId(source.product_id || source.productId || currentPage.productId);
    if (!productId || !normalizeSession(currentSession)) {
      return null;
    }
    var variantId = numericId(source.variant_id || source.variantId || source.id || currentPage.variantId);
    var title = String(source.product_title || source.productTitle || source.title || currentPage.productTitle || '').trim();
    var url = absoluteUrl(source.url || source.product_url || currentPage.productUrl, currentPage.shopOrigin);
    var image = absoluteUrl(source.image || source.product_image || currentPage.productImage, currentPage.shopOrigin);
    return {
      session_id: currentSession,
      product_id: productId,
      variant_id: variantId,
      collection_id: numericId(currentPage.collectionId),
      product_title: title,
      product_image: image,
      product_url: url
    };
  }

  function apiBase() {
    return String(config.apiBase || 'https://importer.4volte.pl/public/social-proof').replace(/\/$/, '');
  }

  function api(path, options) {
    var settings = options || {};
    var headers = {
      Accept: 'application/json',
      'X-Loanti-Session': sessionId
    };
    if (settings.body) {
      headers['Content-Type'] = 'application/json';
    }
    return fetch(apiBase() + path, {
      method: settings.method || 'GET',
      headers: headers,
      body: settings.body ? JSON.stringify(settings.body) : undefined,
      mode: 'cors',
      credentials: 'omit',
      keepalive: !!settings.keepalive
    }).then(function (response) {
      return response.json().catch(function () {
        return {};
      }).then(function (data) {
        log('odpowiedź API', path, response.status, data);
        if (!response.ok || (data && data.ok === false)) {
          var error = new Error((data && data.error) || ('HTTP ' + response.status));
          error.status = response.status;
          throw error;
        }
        return data;
      });
    });
  }

  function isCheckout() {
    return page.pageType === 'checkout' || /\/checkouts?(\/|$)/.test(window.location.pathname);
  }

  function isDrawerOpen() {
    return document.documentElement.classList.contains('js-drawer-open');
  }

  function syncStatsFrame(node) {
    var frame = node && node.closest ? node.closest('[data-loanti-sp-stats]') : null;
    if (!frame) {
      return;
    }
    var ready = frame.querySelectorAll('[data-loanti-sp-state="ready"]').length;
    frame.classList.toggle('is-open', ready > 0);
    frame.classList.toggle('is-lines-2', ready > 1);
  }

  function setStat(kind, state, text) {
    var nodes = document.querySelectorAll('[data-loanti-sp-' + kind + ']');
    Array.prototype.forEach.call(nodes, function (node) {
      node.setAttribute('data-loanti-sp-state', state);
      var label = node.querySelector('[data-loanti-sp-' + kind + '-text]');
      if (label) {
        label.textContent = text || '';
      }
      syncStatsFrame(node);
    });
  }

  function soldCountFrom(data) {
    if (!data || typeof data !== 'object') {
      return 0;
    }
    if (data.sold_count != null) {
      return data.sold_count;
    }
    var days = Number(data.sold_days);
    if (SOLD_DAYS[days] && data['sold_last_' + days + '_days'] != null) {
      return data['sold_last_' + days + '_days'];
    }
    return data.sold_last_30_days;
  }

  function applyStats(viewers, sold, days) {
    if (config.enabled === false) {
      clearStats();
      return;
    }

    if (config.viewerCounter && config.viewerCounter.enabled) {
      if (passesMinimum(viewers, config.viewerCounter.minCount)) {
        setStat('viewers', 'ready', viewerText(viewers));
        log('liczba widzów', Number(viewers));
      } else {
        setStat('viewers', 'empty');
        log('liczba widzów', Number(viewers) || 0);
      }
    } else {
      setStat('viewers', 'empty');
    }

    if (config.soldCounter && config.soldCounter.enabled) {
      var windowDays = Number(days) || soldDays();
      if (passesMinimum(sold, config.soldCounter.minCount)) {
        setStat('sold', 'ready', soldText(sold, windowDays));
        log('sold count', Number(sold), windowDays);
      } else {
        setStat('sold', 'empty');
        log('sold count', Number(sold) || 0, windowDays);
      }
    } else {
      setStat('sold', 'empty');
    }
  }

  function clearStats() {
    setStat('viewers', 'empty');
    setStat('sold', 'empty');
  }

  function refreshStats() {
    if (page.pageType !== 'product' || !numericId(page.productId)) {
      return Promise.resolve();
    }
    if (!(config.viewerCounter && config.viewerCounter.enabled) && !(config.soldCounter && config.soldCounter.enabled)) {
      clearStats();
      return Promise.resolve();
    }
    return api('/product/' + encodeURIComponent(page.productId) + '?days=' + soldDays()).then(function (data) {
      applyStats(data.active_viewers, soldCountFrom(data), data.sold_days || soldDays());
    }).catch(function (error) {
      log('liczniki błąd', error);
    });
  }

  function sendHeartbeat() {
    if (document.hidden || page.pageType !== 'product') {
      return Promise.resolve();
    }
    if (!(config.viewerCounter && config.viewerCounter.enabled)) {
      return Promise.resolve();
    }
    var now = Date.now();
    if (now - lastHeartbeatAt < 25000) {
      return Promise.resolve();
    }
    var payload = buildHeartbeatPayload(page, sessionId);
    if (!payload) {
      return Promise.resolve();
    }
    lastHeartbeatAt = now;
    log('heartbeat', payload);
    return api('/heartbeat', { method: 'POST', body: payload }).then(function () {
      return refreshStats();
    }).catch(function (error) {
      lastHeartbeatAt = 0;
      log('heartbeat błąd', error);
    });
  }

  function startHeartbeat() {
    if (page.pageType !== 'product') {
      return;
    }
    if (config.viewerCounter && config.viewerCounter.enabled) {
      sendHeartbeat();
      heartbeatTimer = window.setInterval(sendHeartbeat, HEARTBEAT_MS);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) {
          sendHeartbeat();
        }
      });
      return;
    }
    if (config.soldCounter && config.soldCounter.enabled) {
      refreshStats();
      soldTimer = window.setInterval(refreshStats, 60000);
    }
  }

  function kickerFor(event, current) {
    var source = current || config;
    if (event && event.event_type === 'add_to_cart') {
      return (source.cartPopup && source.cartPopup.text) || 'Ktoś dodał ten produkt do koszyka';
    }
    return (source.purchasePopup && source.purchasePopup.text) || 'Ktoś właśnie kupił';
  }

  function popupSettingsFor(event) {
    if (event && event.event_type === 'add_to_cart') {
      return config.cartPopup || {};
    }
    return config.purchasePopup || {};
  }

  function hidePopup(immediate) {
    if (!popup) {
      return;
    }
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    if (autoHideTimer) {
      window.clearTimeout(autoHideTimer);
      autoHideTimer = null;
    }
    if (hideTimer) {
      window.clearTimeout(hideTimer);
    }
    var finish = function () {
      if (popup) {
        popup.classList.remove('is-shown');
      }
    };
    if (immediate) {
      finish();
      return;
    }
    hideTimer = window.setTimeout(finish, 380);
  }

  function showPopup(event, options) {
    if (!popup || !event) {
      return;
    }
    var settings = options || {};
    var popupCfg = popupSettingsFor(event);
    var link = popup.querySelector('[data-loanti-sp-link]');
    var image = popup.querySelector('[data-loanti-sp-image]');
    var kicker = popup.querySelector('[data-loanti-sp-kicker]');
    var title = popup.querySelector('[data-loanti-sp-title]');
    var closeButton = popup.querySelector('[data-loanti-sp-close]');
    var imageUrl = absoluteUrl(event.product_image, page.shopOrigin);
    var productUrl = absoluteUrl(event.product_url, page.shopOrigin) || '#';
    var showImage = popupCfg.showImage !== false;
    var showTitle = popupCfg.showTitle !== false;
    var visibleMs = POPUP_VISIBLE_MS;
    var displaySeconds = Number(popupCfg.displaySeconds);
    if (isFinite(displaySeconds) && displaySeconds > 0) {
      visibleMs = displaySeconds * 1000;
    }

    if (kicker) {
      kicker.textContent = kickerFor(event);
    }
    if (title) {
      title.hidden = !showTitle;
      title.textContent = showTitle ? String(event.product_title || '') : '';
    }
    if (closeButton) {
      closeButton.hidden = popupCfg.showClose === false;
    }
    if (link) {
      link.setAttribute('href', productUrl);
    }
    var imageWrap = image ? image.parentNode : null;
    if (image) {
      if (showImage && imageUrl) {
        image.hidden = false;
        image.src = imageUrl;
        if (imageWrap) {
          imageWrap.hidden = false;
        }
      } else {
        image.removeAttribute('src');
        image.hidden = true;
        if (imageWrap) {
          imageWrap.hidden = true;
        }
      }
    }

    popup.setAttribute('data-event-id', settings.track ? String(event.id || '') : '');
    popup.setAttribute('data-local-test', settings.track ? '0' : '1');
    popup.setAttribute('data-open-product', popupCfg.clickOpensProduct === false ? '0' : '1');
    popup.classList.add('is-shown');
    popup.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(function () {
      if (popup) {
        popup.classList.add('is-visible');
      }
    });

    if (autoHideTimer) {
      window.clearTimeout(autoHideTimer);
    }
    autoHideTimer = window.setTimeout(function () {
      hidePopup(false);
    }, visibleMs);

    if (settings.track && event.id) {
      rememberShown(event.id);
      api('/impression', {
        method: 'POST',
        body: {
          session_id: sessionId,
          event_id: Number(event.id),
          page_type: KNOWN_PAGE_TYPES[page.pageType] ? page.pageType : 'other'
        }
      }).catch(function (error) {
        log('impression błąd', error);
      });
    }
  }

  function rememberShown(eventId) {
    var state = loadState();
    var now = Date.now();
    var windowMs = ((config.frequency && config.frequency.windowMinutes) || 30) * 60 * 1000;
    state.shownAt = activeShows(state, now, windowMs);
    state.shownAt.push(now);
    if (eventId) {
      state.seenIds.push(String(eventId));
    }
    saveState(state);
  }

  function rememberMute(seconds) {
    var state = loadState();
    var parsed = Number(seconds);
    var wait = isFinite(parsed) ? parsed : 120;
    var until = Date.now() + wait * 1000;
    if (until > (state.muteUntil || 0)) {
      state.muteUntil = until;
    }
    saveState(state);
    log('wyciszenie popupów', state.muteUntil);
  }

  function scheduleNext() {
    if (showTimer) {
      window.clearTimeout(showTimer);
      showTimer = null;
    }
    var decision = planWait(loadState(), Date.now(), config, {
      pageType: page.pageType,
      drawerOpen: isDrawerOpen()
    });
    log('frequency cap', decision);
    if (decision.stop) {
      return;
    }
    showTimer = window.setTimeout(function () {
      if (decision.reason === 'delay') {
        tryShow();
        return;
      }
      scheduleNext();
    }, decision.waitMs);
  }

  function tryShow() {
    var decision = planWait(loadState(), Date.now(), config, {
      pageType: page.pageType,
      drawerOpen: isDrawerOpen()
    });
    if (decision.stop) {
      return;
    }
    if (decision.reason !== 'delay') {
      scheduleNext();
      return;
    }

    var path = eventsPath();
    api(path).then(function (data) {
      var events = (data && data.events) || [];
      log('odebrane eventy', events);
      var again = planWait(loadState(), Date.now(), config, {
        pageType: page.pageType,
        drawerOpen: isDrawerOpen()
      });
      if (again.reason === 'drawer' || again.reason === 'mute' || again.reason === 'cap' || again.stop) {
        scheduleNext();
        return;
      }
      var chosen = pickEvent(events, page, loadState().seenIds, config);
      if (!chosen) {
        log('brak nowego eventu');
        showTimer = window.setTimeout(tryShow, 30000);
        return;
      }
      showPopup(chosen, { track: true });
      scheduleNext();
    }).catch(function (error) {
      log('eventy błąd', error);
      showTimer = window.setTimeout(tryShow, 30000);
    });
  }

  function eventsPath() {
    var params = ['limit=20'];
    if (page.pageType === 'product' && numericId(page.productId)) {
      params.push('product_id=' + encodeURIComponent(page.productId));
    }
    if ((page.pageType === 'product' || page.pageType === 'collection') && numericId(page.collectionId)) {
      params.push('collection_id=' + encodeURIComponent(page.collectionId));
    }
    return '/events?' + params.join('&');
  }

  function syncCartAttribute() {
    if (!window.theme || !theme.cart || typeof theme.cart.getCart !== 'function' || typeof theme.cart.updateAttribute !== 'function') {
      return Promise.resolve();
    }

    var run = function () {
      return theme.cart.getCart().then(function (cart) {
        var attrs = (cart && cart.attributes) || {};
        log('atrybuty koszyka', attrs);
        if (String(attrs[CART_ATTRIBUTE] || '') === sessionId) {
          return cart;
        }
        var delivery = attrs[DELIVERY_ATTRIBUTE];
        return theme.cart.updateAttribute(CART_ATTRIBUTE, sessionId).then(function () {
          return theme.cart.getCart();
        }).then(function (latest) {
          var after = (latest && latest.attributes) || {};
          log('atrybuty koszyka po zapisie', after);
          if (delivery && !after[DELIVERY_ATTRIBUTE]) {
            log('przywracam Metodę dostawy');
            return theme.cart.updateAttribute(DELIVERY_ATTRIBUTE, delivery);
          }
          return latest;
        });
      });
    };

    attributeSync = Promise.resolve(attributeSync).then(run, run);
    return attributeSync.catch(function (error) {
      log('zapis atrybutu koszyka błąd', error);
    });
  }

  function onAdded(event) {
    var item = event && event.detail ? event.detail.product : null;
    log('ajaxProduct:added', item);
    rememberMute(config.muteAfterAddToCartSeconds);
    hidePopup(true);
    scheduleNext();
    var payload = buildAddToCartPayload(item, sessionId, page);
    if (!payload) {
      log('add_to_cart pominięte, brak produktu');
      return;
    }
    log('add_to_cart', payload);
    api('/add-to-cart', { method: 'POST', body: payload }).catch(function (error) {
      log('add_to_cart błąd', error);
    });
    syncCartAttribute();
  }

  function onPopupClick(event) {
    var link = event.target.closest('[data-loanti-sp-link]');
    if (!link || !popup || !popup.contains(link)) {
      return;
    }
    var href = link.getAttribute('href');
    var eventId = popup.getAttribute('data-event-id');
    var isTest = popup.getAttribute('data-local-test') === '1';
    if (!href || href === '#') {
      event.preventDefault();
      return;
    }
    var opensProduct = popup.getAttribute('data-open-product') !== '0';
    if (!opensProduct) {
      event.preventDefault();
    }
    if (isTest || !eventId) {
      return;
    }
    event.preventDefault();
    api('/click', {
      method: 'POST',
      body: {
        session_id: sessionId,
        event_id: Number(eventId)
      },
      keepalive: true
    }).catch(function (error) {
      log('click błąd', error);
    });
    if (!opensProduct) {
      return;
    }
    window.setTimeout(function () {
      window.location.href = href;
    }, 60);
  }

  function bindPopup() {
    root = document.querySelector('[data-loanti-social-proof]');
    popup = document.querySelector('[data-loanti-sp-popup]');
    if (!root || !popup || root.getAttribute('data-loanti-sp-booted') === '1') {
      return false;
    }
    root.setAttribute('data-loanti-sp-booted', '1');
    applyAppearance(config);

    var closeButton = popup.querySelector('[data-loanti-sp-close]');
    if (closeButton) {
      closeButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        hidePopup(false);
      });
    }
    root.addEventListener('click', onPopupClick);

    var image = popup.querySelector('[data-loanti-sp-image]');
    if (image) {
      image.addEventListener('error', function () {
        image.hidden = true;
        if (image.parentNode) {
          image.parentNode.hidden = true;
        }
      });
    }

    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (isDrawerOpen()) {
          hidePopup(true);
          scheduleNext();
        }
      }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }
    document.addEventListener('drawerOpen.CartDrawer', function () {
      hidePopup(true);
      scheduleNext();
    });
    return true;
  }

  function showTestPopup(kind) {
    if (!isDebug()) {
      console.warn('[Loanti Social Proof] Najpierw ustaw window.LOANTI_SOCIAL_PROOF_DEBUG = true');
      return;
    }
    var purchase = kind !== 'cart';
    showPopup({
      id: 0,
      event_type: purchase ? 'purchase' : 'add_to_cart',
      product_title: page.productTitle || 'Testowy produkt',
      product_url: page.productUrl || (page.shopOrigin ? page.shopOrigin + '/' : '#'),
      product_image: page.productImage || ''
    }, { track: false });
    log('ręczny popup', purchase ? 'purchase' : 'cart');
  }

  function start() {
    if (booted || isCheckout() || config.enabled === false) {
      if (config.enabled === false) {
        clearStats();
      }
      return;
    }
    booted = true;
    log('sesja', sessionId, sessionRecord.created ? 'nowa' : 'zachowana');
    log('strona', page);

    if (!(config.viewerCounter && config.viewerCounter.enabled)) {
      setStat('viewers', 'empty');
    }
    if (!(config.soldCounter && config.soldCounter.enabled)) {
      setStat('sold', 'empty');
    }

    bindPopup();
    document.addEventListener('ajaxProduct:added', onAdded);
    syncCartAttribute();
    startHeartbeat();
    scheduleNext();
  }

  window.LoantiSocialProof = {
    showTestPopup: showTestPopup,
    getSessionId: function () {
      return sessionId;
    },
    getState: function () {
      return loadState();
    },
    getConfig: function () {
      return config;
    },
    applyStats: applyStats,
    rules: {
      viewerText: viewerText,
      soldText: soldText,
      pickEvent: pickEvent,
      planWait: planWait,
      readOrCreateSession: readOrCreateSession,
      buildAddToCartPayload: buildAddToCartPayload,
      buildHeartbeatPayload: buildHeartbeatPayload,
      normalizeSession: normalizeSession,
      createSessionId: createSessionId,
      SESSION_KEY: SESSION_KEY,
      STATE_KEY: STATE_KEY,
      LIMITS_REVISION_KEY: LIMITS_REVISION_KEY,
      mergeConfig: mergeConfig,
      loadRemoteConfig: loadRemoteConfig,
      appearanceVars: appearanceVars,
      applyLimitsRevision: applyLimitsRevision,
      soldDays: soldDays,
      pageAllowed: pageAllowed,
      passesMinimum: passesMinimum,
      kickerFor: kickerFor,
      soldCountFrom: soldCountFrom
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
